import React from 'react';
import {AreaChart as RechartAreaChart, CartesianGrid, XAxis, YAxis, Tooltip, ReferenceLine, Area} from 'recharts';

import TooltipContent, {ChartType} from './TooltipContent';
import {ChartProps, VisibleAttribute} from '../../types/Chart';
import {BarChartData} from './BarChart';
import {colorToString} from '../../utility/ColorUtils';
import {BlackColor} from '../../styles/colors';

interface AreaChartProps extends ChartProps {
    data: BarChartData[];
    onBarClick: (payload: BarChartData) => void;
    allowAnimation?: boolean;
    currencyFormatting: (value: number) => string;
}

const roundLowNumbers = (resultNumber: number): number => {
    if (resultNumber < 1) {
        return Math.round(resultNumber * 1000) / 1000;
    }
    return resultNumber;
};

export default class AreaChart extends React.Component<AreaChartProps, {}> {
    private renderArea = (areaAttribute: VisibleAttribute) => {
        const {useAbsValue} = areaAttribute;
        const {isCompareDiagram, isChannelDiagram, kpi, searchtermOrProductId, channel} = areaAttribute.kpiRequestInfo;
        const color = colorToString(areaAttribute.color);
        return (
            <Area
                type="monotone"
                stackId="1"
                isAnimationActive={this.props.allowAnimation === true}
                dataKey={(singleEntry: BarChartData) => {
                    const dataSet = singleEntry.data.find(
                        (data) =>
                            data.channel.name === channel.name &&
                            data.searchtermOrProductId === searchtermOrProductId &&
                            data.kpi === kpi &&
                            data.isChannelDiagram === isChannelDiagram &&
                            data.isCompareDiagram === isCompareDiagram
                    );
                    if (dataSet !== undefined) {
                        return roundLowNumbers(useAbsValue !== undefined && !useAbsValue ? dataSet.relValue : dataSet.value);
                    }
                    return null;
                }}
                key={color + ':' + areaAttribute.kpiRequestInfo.isCompareDiagram}
                stroke={color}
                fill={color}
            />
        );
    };

    public render(): React.ReactNode {
        return (
            <RechartAreaChart
                width={this.props.width}
                height={this.props.height}
                data={this.props.data}
                onClick={(e) => {
                    if (!e) {
                        return;
                    }

                    const activePayload = e.activePayload?.[0];
                    console.log('TODO PAYLOAD', activePayload);
                    if (activePayload !== undefined) {
                        this.props.onBarClick(activePayload.payload);
                    }
                }}
                margin={{top: 0, right: 0, left: 20, bottom: 0}}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="category" dataKey="name" hide={true} />;
                <YAxis type="number" />;
                <Tooltip
                    content={
                        <TooltipContent
                            kpiPackageToString={this.props.kpiPackageToString}
                            visibleAttribute={this.props.visibleAttribute}
                            payload={undefined}
                            currencyFormatting={this.props.currencyFormatting}
                            tooltipComparisonModeIfOneElementIsSelected={this.props.tooltipComparisonModeIfOneElementIsSelected}
                            chartType={ChartType.BAR_CHART}
                        />
                    }
                />
                <ReferenceLine y={0} stroke={BlackColor} />
                {this.props.visibleAttribute.map(this.renderArea)}
            </RechartAreaChart>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/charts/AreaChart.tsx